import React from 'react'
import '../Destination/Destination.css'
import DestinationOffer from '../DestinationOffer/DestinationOffer'
import Why from '../Why/Why'
const Destination = () => {
  return (
   <>
    <div className="post-d">
                <div className="overlay-d">
                    <h1 className="text-d">Our Holidays</h1>
                </div>
            </div>
            <DestinationOffer/>
            <Why/>
   </>
  )
}

export default Destination